module.exports = __webpack_public_path__ + "img/table_tennis_session.e51144a1.jpg";